import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import React from 'react';
import locale from '../customReports-locale.json';
import { SelectedFile } from './SelectedFile';
import { styles } from './FileSelectedStep.styles';
import { Mode } from './NewExcelFileModal';

type Props = {
  selectedFile: File;
  mode: Mode;
  onReUpload: () => void;
  customReportName: string;
  setCustomReportName: React.Dispatch<React.SetStateAction<string>>;
};

export function FileSelectedStep({ selectedFile, mode, customReportName, setCustomReportName, onReUpload }: Props) {
  const MAX_REPORT_NAME_CHARS = 60;

  return (
    <Box sx={styles.container} data-test="new-excel-file-file-selected-step">
      <Grid container spacing={3}>
        {mode.variant === 'update' ? (
          <Grid item xs={12}>
            <Alert variant="filled" severity="warning" sx={styles.confirmFileWarning} data-test="confirm-file-warning">
              <AlertTitle>{locale.addNewExcelFileModal.confirmFile}</AlertTitle>
              <Typography>{locale.addNewExcelFileModal.confirmFileDescription}</Typography>
            </Alert>
          </Grid>
        ) : null}

        <Grid item xs={12}>
          <SelectedFile fileName={selectedFile.name} onReUpload={onReUpload} />
        </Grid>

        <Grid item xs={12} md={6}>
          <Box>
            <TextField
              value={customReportName}
              onChange={(e) => setCustomReportName(e.target.value)}
              label={locale.addNewExcelFileModal.customReportName}
              fullWidth
              sx={styles.textField}
              inputProps={{ className: 'no-format', maxLength: MAX_REPORT_NAME_CHARS }}
              data-test="custom-report-name-input"
            />
            <Typography
              variant="caption"
              sx={[
                styles.characterCount,
                customReportName.length >= MAX_REPORT_NAME_CHARS ? styles.countError : styles.countDefault
              ]}
            >
              {customReportName.length}/{MAX_REPORT_NAME_CHARS}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            value="refresh-on-upload"
            disabled
            label={locale.addNewExcelFileModal.dataUpdateFrequency}
            fullWidth
            select
            sx={styles.textField}
            inputProps={{ className: 'no-format' }}
          >
            <MenuItem value="refresh-on-upload">{locale.addNewExcelFileModal.refreshOnUpload}</MenuItem>
          </TextField>
        </Grid>
      </Grid>

      <Box sx={styles.sheetsSection}>
        <Typography variant="body1" sx={styles.sectionDescription}>
          <strong>{locale.addNewExcelFileModal.note}:</strong> {locale.addNewExcelFileModal.namedRangesNote}
        </Typography>
      </Box>
    </Box>
  );
}
